<template>
  <div>
    <v-dialog v-model="$store.state.demoDialog" width="70vw" height="auto">
      <div class="demo-modal-container">
        <div class="demo-modal-header">
          <div>
            <img
              class="header-menu-image"
              :src="`${require('@/assets/images/logoColoredWhite.png')}`"
              alt="header logo image"
              @click="$router.push('/')"
            />
          </div>
          <div>
            <i
              class="mdi mdi-close demo-modal-header-close"
              @click="setDemoDialog(false)"
            ></i>
          </div>
        </div>
        <div class="row demo-modal-body">
          <div class="col-lg-9 col-12 h-100">
            <div class="demo-modal-body-left">
              <div class="demo-modal-body-disclaimer">
                <div class="demo-modal-body-title">Before you continue…</div>
                <div class="demo-modal-body-desc">
                  <b>Book a free demo class</b> and get a feel for our method,
                  meet a real instructor, and ask all your questions, no
                  pressure, no commitment.
                </div>
              </div>
              <div
                class="calendly-inline-widget"
                :data-url="`https://calendly.com/comligo/45min?background_color=ffffff&text_color=111118&primary_color=e05025&hide_gdpr_banner=1${
                  gcl() ? `&utm_source=${gcl()}` : ''
                }`"
                :style="{
                  width: '100%',
                  height: width,
                  zoom,
                }"
              >
                <div
                  v-if="calendarLoaded"
                  class="trusted-companies-swiper-title text-center"
                >
                  Almost there—your calendar is loading!
                </div>
              </div>
              <div class="demo-modal-body-disclaimer">
                By booking a demo, you agree to our
                <span
                  class="disclaimer-link"
                  @click="$router.push('/privacy-policy')"
                  >Privacy Policy</span
                >
                and
                <span
                  class="disclaimer-link"
                  @click="$router.push('/terms-and-conditions')"
                  >Terms & Conditions</span
                >
              </div>
            </div>
          </div>
          <div
            class="col-lg-3 col-12 h-100 d-flex align-items-center justify-content-center"
          >
            <div class="demo-modal-body-right">
              <img
                class="demo-modal-image"
                src="https://firebasestorage.googleapis.com/v0/b/comligo-website-v2.appspot.com/o/audio%2FHealthcare%20Staff%20Beginners%2Fbook-demo.png?alt=media&token=7859394d-dd70-490d-b21b-bab58494f93f"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: true,
      calendarLoaded: true,
    };
  },
  watch: {
    "$store.state.demoDialog": function (val) {
      if (val) {
        this.loadCalendly();
      }
    },
  },
  computed: {
    width() {
      const width = window?.screen?.width;
      if (width >= 2000) return "27vw";
      if (width === 1800) return "39vw";
      if (width === 1024) return "66vw";
      const m = (66 - 39) / (1024 - 1800);
      const b = 39 - m * 1800;

      return this.isMobile
        ? this.calendarLoaded
          ? "400px"
          : "1000px"
        : `${Math.round(m * width + b)}vw`;
    },
    isMobile() {
      const width = window?.screen?.width;
      if (width <= 800) return true;
      return false;
    },
    zoom() {
      const width = window?.screen?.width;
      if (width >= 2000) return "100%";
      if (width === 1800) return "75%";
      if (width === 1024) return "42%";
      const m = (42 - 75) / (1024 - 1800);
      const b = 75 - m * 1800;

      return this.isMobile ? "100%" : `${Math.round(m * width + b)}%`;
    },
  },
  methods: {
    ...mapMutations(["setDemoDialog"]),
    gcl() {
      return localStorage?.gcl;
    },
    loadCalendly() {
      const preloadLink = document.createElement("link");
      preloadLink.rel = "preload";
      preloadLink.as = "script";
      preloadLink.href =
        "https://assets.calendly.com/assets/external/widget.js";
      document.head.appendChild(preloadLink);

      const script = document.createElement("script");
      script.onload = () => {
        window.addEventListener("message", (e) => {
          if (
            e.data.event &&
            e.data.event.indexOf("calendly") === 0 &&
            e.data.event === "calendly.event_type_viewed"
          ) {
            this.calendarLoaded = false;
          }
        });
      };
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      document.head.appendChild(script);
    },
  },
};
</script>

<style></style>
